import { isBrowser } from '~/constants';

export const getCookies = () => {
    if (!isBrowser) {
        return {};
    }
    return Object.fromEntries(
        document.cookie
            .split(';')
            .map((c) => c.trim())
            .filter(Boolean)
            .map((v) => {
                const [name, ...rest] = v.split('=');
                const value = rest.join('=');
                return [
                    decodeURIComponent(name.trim()),
                    decodeURIComponent(value),
                ];
            })
    );
};

export const getCookie = (name: string) => {
    const cookies = getCookies();
    return cookies[name];
};

export const setCookie = (
    name: string,
    value: string,
    options: {
        path?: string;
        expires?: number | string | Date;
        maxAge?: number; // Seconds
        domain?: string;
        secure?: boolean;
        sameSite?: 'Strict' | 'Lax' | 'None'; // Default is 'Lax'
    } = {}
) => {
    if (!isBrowser) return;

    let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    // Opções do cookie
    if (options.expires instanceof Date) {
        updatedCookie += `; expires=${options.expires.toUTCString()}`;
    } else if (typeof options.expires === 'number') {
        const date = new Date();
        date.setTime(date.getTime() + options.expires * 1000);
        updatedCookie += `; expires=${date.toUTCString()}`;
    } else if (typeof options.expires === 'string') {
        updatedCookie += `; expires=${options.expires}`;
    }

    if (options.maxAge) {
        updatedCookie += `; max-age=${options.maxAge}`;
    }

    if (options.path) {
        updatedCookie += `; path=${options.path}`;
    }

    if (options.domain) {
        updatedCookie += `; domain=${options.domain}`;
    }

    if (options.secure) {
        updatedCookie += '; secure';
    }

    if (options.sameSite) {
        updatedCookie += `; samesite=${options.sameSite}`;
    }

    document.cookie = updatedCookie;
};

export function getCookieValue(
    cookieHeader: string | null,
    cookieName: string
): string | null {
    if (!cookieHeader) {
        return null;
    }

    const cookies = cookieHeader
        .split(';')
        .map((c) => c.trim())
        .filter(Boolean)
        .reduce((acc: Record<string, string>, cookie) => {
            const [name, ...value] = cookie.split('=');
            const key = decodeURIComponent(name.trim());
            const val = decodeURIComponent(value.join('='));
            acc[key] = val;
            return acc;
        }, {});

    return cookies[cookieName] ?? null;
}
